const authorizationTypeOptions = [
  { label: 'Product Specific', value: 'SPECIFIC' },
  { label: 'Unlimited', value: 'UNLIMITED' },
  { label: 'Limited', value: 'LIMITED' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Semi-Monthly', value: 'SEMIMONTHLY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Daily', value: 'DAILY' },
  { label: '1 Vol Daily', value: 'ONEVOLDAILY' },
  { label: '1 Vol Weekly', value: 'ONEVOLWEEKLY' },
  { label: '1 Vol Monthly', value: 'ONEVOLMONTH' },
  { label: 'One Time', value: 'ONETIME' },
  { label: 'One Load', value: 'ONELOAD' },
];

export default authorizationTypeOptions;
